module.exports = __webpack_public_path__ + "static/media/doctorandappointmentslot.28268b59.svg";